import vueRouter from 'vue-router'
export default function createRouter() {
    return new vueRouter({
        mode: 'history', //一定要是history模式
        routes: [/* {
                path: "/live/",
                name:'home',
                component: resolve => require([`./views/live/liveList.vue`], resolve)
            }, */
            /*拍卖直播--列表*/
            {
                path: "/live",
                name: 'live',
                component: resolve => require([`./views/live/liveList.vue`], resolve) /*拍卖直播--列表*/
            },
            /*拍卖直播--内容*/
            {
                path: "/live/detail",
                name: 'live/detail',
                component: resolve => require([`./views/live/index`], resolve) /*拍卖直播--内容*/
            },
            /*拍品--详情*/
            {
                path: "/live/auction/:liveid/:art_id/:special_id",
                name: 'live/auction',
                component: resolve => require([`./views/live/liveDetails.vue`], resolve) /*拍品--详情*/
            },
            {
                path:'/metrics',
                name:'metrics',
                component :resolve => require([`./views/404`], resolve) /*404*/
            },
            {
                path:'*',
                redirect:'/live'
            }
        ]
    })
}
